export class Staff {
  constructor(staff) {
    this.user_id = staff.user_id;
    this.name = staff.name;
    this.color_code = staff.color_code;
    this.image_url = staff.image_url;
  }
}
